<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
    import { createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';

    export let disableClosing = false;

    const dispatch = createEventDispatcher();

    function close() {
        if (!disableClosing) {
            dispatch('close');
        }
    }
</script>

<style>
    .modal-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        z-index: var(--layer-4);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .modal-background {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--color-bg-default);
        opacity: 0.75;
        z-index: var(--layer-4);
    }
</style>

<div class="modal-wrapper" transition:fade="{{ duration: 150 }}">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="modal-background" on:click={close}></div>
    <slot></slot>
</div>
